import type { User } from 'firebase/auth';
import { create } from 'zustand';

export type SessionUser = User | null;

export type SessionState = {
  user: SessionUser;
  authToken: string | null;
  isInitialized: boolean;
  isAuthenticated: boolean;
};

export type SessionActions = {
  setSessionUser: (user: SessionUser) => void;
  setSessionAuthToken: (authToken: string | null) => void;
  setIsAuthenticated: (isAuthenticated: boolean) => void;
  resetSessionState: () => void;
  setSessionInitialized: (isInitialized: boolean) => void;
};

type SessionStore = SessionState & SessionActions;

const initialState: SessionState = {
  user: null,
  authToken: null,
  isInitialized: false,
  isAuthenticated: false,
};

export const useSessionStore = create<SessionStore>(set => ({
  ...initialState,

  resetSessionState: () => {
    set({
      ...initialState,
      isInitialized: true,
    });
  },

  setSessionAuthToken: (authToken: string | null) => {
    set({
      authToken,
    });
  },
  setIsAuthenticated: (isAuthenticated: boolean) => {
    set({
      isAuthenticated,
    });
  },

  setSessionUser: (user: SessionUser) => {
    set({
      user,
    });
  },
  setSessionInitialized: (isInitialized: boolean) => {
    set({
      isInitialized,
    });
  },
}));

export const selectSessionState = (state: SessionStore): SessionState => ({
  user: state.user,
  authToken: state.authToken,
  isInitialized: state.isInitialized,
  isAuthenticated: state.isAuthenticated,
});

export const selectSessionActions = (state: SessionStore): SessionActions => ({
  setSessionUser: state.setSessionUser,
  setSessionAuthToken: state.setSessionAuthToken,
  resetSessionState: state.resetSessionState,
  setSessionInitialized: state.setSessionInitialized,
  setIsAuthenticated: state.setIsAuthenticated,
});
